import { Component, AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { MatSidenav } from '@angular/material/sidenav';
import { User } from '@app/_models';
import { AccountService, LoggerService, ConnectionStatusService } from '@app/_services';
import { environment } from '@environments/environment';
import { Observable, Subject } from 'rxjs';
import { reduce, takeUntil } from 'rxjs/operators';
import packageJson from '../../package.json';



@Component({
  standalone: false,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.sass']
})
export class AppComponent implements AfterViewInit, OnDestroy {

  private destroy$ = new Subject<void>();
  @ViewChild('sidenav') sidenav!: MatSidenav;

  version = packageJson.version;
  title = 'Backoffice Meloni';
  versionNumber =  'v. '+ this.version

  copyright = '© 2020 - ' + (new Date()).getFullYear() + ' - MCDataSolutions';
  user: User | null = null;
  menu: string[] = []
  isServerReachable = true;
  sidenavOpened = true; // Sidenav open by default on desktop
  isCollapsed = false;

  constructor(
    private accountService: AccountService,
    private logger: LoggerService,
    private connectionStatus: ConnectionStatusService
  ) {
    this.accountService.user
      .pipe(takeUntil(this.destroy$))
      .subscribe(x => this.user = x);
    this.accountService.menu
      .pipe(takeUntil(this.destroy$))
      .subscribe(x => this.menu = x);
    this.connectionStatus.connectionStatus$
      .pipe(takeUntil(this.destroy$))
      .subscribe(status => this.isServerReachable = status);
    if (environment.production) {
      this.versionNumber = this.versionNumber + ' PRODUZIONE'
    }else{
      this.versionNumber = this.versionNumber + ' TEST'
    }

  }

  ngAfterViewInit() {
    if(this.user) {
      this.accountService.refreshUserMenu()
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          error: err => this.logger.error("Failed to refresh user menu", err)
        });
    }
  }

  logout() {
    this.accountService.logout();
  }

  toggleSidenav() {
    this.isCollapsed = !this.isCollapsed;
    // Trigger window resize to force Angular Material to recalculate layout
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 10);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}

// segui esempio per gestione autenticazione (controller e service)
// https://jasonwatmore.com/post/2020/04/28/angular-9-user-registration-and-login-example-tutorial